/*@flow*/
import type { StateT } from './types';
import Present from 'lib/Present';

export default (s: StateT): ((elementName: string) => boolean) => (elementName: string) => {
  let isDisabled = false;
  switch (elementName) {
    case 'EDIT_AREA_BUTTON':
      isDisabled = !Present.is(s.areaWorkingCopy.geojson);
      break;
    case 'CREATE_NEW_AREA_BUTTON':
      isDisabled = Boolean(s.showEditOverlay);
      break;
    case 'CLONE_AREA_BUTTON':
    case 'DELETE_AREA_BUTTON':
    case 'TABLES_BUTTON':
    case 'ALERTS_BUTTON':
    case 'SHARE_MAPS_BUTTON':
      isDisabled = !Present.is(s.areaWorkingCopy.id);
      break;
    case 'NEW_AREA_BUTTON':
      break;
    default:
      throw new Error('Unrecognized UI element `' + elementName + '`');
  }
  return isDisabled;
};
